import React, { FunctionComponent } from "react";
import { Link } from "gatsby";
import { TOPICS, TopicKey } from "../../topics";
import { PostSnippet } from "../../types";
import { formatDate, formatReadingTime } from "../../data/format";
import { EMPTY_TOPIC_NOTE } from "../emptySection";

export interface OtherTopics {
  topics: { topic: TopicKey; latest?: PostSnippet }[];
}

/** Home page row: one column per remaining topic with its latest post or an empty state. */
export const OtherTopics: FunctionComponent<OtherTopics> = ({ topics }) => (
  <div className="grid grid-cols-1 gap-8 px-gutter-sm pb-[72px] pt-10 md:grid-cols-2 md:px-gutter lg:grid-cols-3">
    {topics.map(({ topic, latest }) => (
      <div
        key={topic}
        className={`flex flex-col gap-2.5 border-t-[6px] pt-3.5 ${TOPICS[topic].borderClass}`}
      >
        <Link
          to={TOPICS[topic].href}
          className="font-display text-h3 font-extrabold tracking-[-0.02em] hover:text-spark"
        >
          {TOPICS[topic].name}
        </Link>
        {latest ? (
          <>
            <Link
              to={latest.href}
              className="font-display text-xl font-semibold transition-colors duration-maker ease-maker hover:text-spark"
            >
              {latest.title}
            </Link>
            <div className="text-[15px] text-muted">
              {formatDate(latest.publishedDate)} ·{" "}
              {formatReadingTime(latest.readingTime)}
            </div>
          </>
        ) : (
          <p className="text-body-sm italic text-body-2">
            {TOPICS[topic].description} {EMPTY_TOPIC_NOTE}
          </p>
        )}
      </div>
    ))}
  </div>
);
